import { RoutePlannerModal } from '@lp/features/RoutePlanner/components/RouteModals/components/RoutePlannerModal';
import { Case } from '@/api/apis/case';
import { CompareModalBody } from './CompareModalBody';

type CompareModalProps = {
  taskId: string;
  chainNumber: number;
  caseData: Case;
  isOpen: boolean;
  onCloseModal: () => void;
};

export const CompareModal = ({ taskId, chainNumber, caseData, isOpen, onCloseModal }: CompareModalProps) => (
  <RoutePlannerModal
    size="5xl"
    baseClassName="max-w-[1226px]"
    headerTitleClassName="text-hm! pt-4 pb-0"
    closeButtonClassName="text-base-10 m-2"
    bodyClassName="px-4 pb-4"
    title="Compare"
    isOpen={isOpen}
    onClose={onCloseModal}
  >
    <CompareModalBody taskId={taskId} chainNumber={chainNumber} caseData={caseData} />
  </RoutePlannerModal>
);
